import './bootstrap';
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './components/App.vue';
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import router from './router'
import store, { ActionTypes } from './store';
import axios from 'axios'
import { setupServiceWorkerUpdateHandler } from './sw-update-handler'
import { setFlowLoader } from '@/components/wizard/flowSource'
import { apiFlow } from '@/api/apiFlow'
import './pwa-handler.js';
import I18NextVue from 'i18next-vue'
import i18next from './i18n.ts'
// Import CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import '@coreui/coreui-pro/dist/css/coreui.min.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'photoswipe/style.css'



// FontAwesome - carica solo le icone necessarie
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faRotate, faPlus, faUser, faCog, faList, faRightFromBracket,
  faGear, faRoadBarrier, faLocationCrosshairs, faLocationDot, faBox, faPaperclip,
  faSquareParking, faTrash, faPenToSquare, faFloppyDisk, faXmark,
  faBook, faCamera, faPhotoFilm, faFileLines, faCircleDot,
  faWrench, faCar, faRefresh, faDeleteLeft, faCheck, faDownload, faBackward, faPlay, faMagnifyingGlass,
  faBars, faTriangleExclamation, faPen, faArrowUpRightFromSquare, faArrowDown, faArrowUp, faTrashCan, faSave, faArrowsLeftRight, faArrowRight, faFilter, faTableColumns, faPerson, faMagnifyingGlassArrowRight, faClock, faPeopleGroup, faHome, faAngleDown, faAngleUp, faCircle, faTable, faPeopleCarryBox,
  faStop, faEye,faArrowRotateBack,
  faHammer,
  faX
  , faSun, faMoon,faShareFromSquare,faClockRotateLeft,faFilePdf,
  faCopy,
  faCalculator,
  faListCheck,
  faLock,
  faRoute,
  faLinkSlash,
  faFileImport,
  faClipboardList,
  faScrewdriverWrench,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faArrowLeft,
  faCircleInfo,
  faNoteSticky,
  faUsers,
  faUserGroup,
  faFolderOpen,
  faCircleCheck,
  faCalendarDay,
  faSignature,
  faPaperPlane,
  faBrain,
  faTruck,
  faEnvelopeOpen,
  faEnvelope,
  faMobileScreen,
  faArrowRotateRight,
  faFaceFrown,
  faMessage,
  faRoad,
  faSnowflake,
  faCloudSun,
  faCloudArrowDown,
  faStopwatch,
  faBuilding,
  faHeart,
  faPaintRoller,
  faFileExcel,
  faRightLeft,
  // icone selezionabili per i SERVIZI (vedi src/api/serviziIcone.ts)
  faCarSide, faGasPump, faKey, faShieldHalved, faOilCan, faCarBattery, faGears,
  faDroplet, faToolbox, faBroom, faHandshake, faStar, faTag, faBolt,
  faTruckPickup, faSprayCanSparkles, faWindowMaximize, faCarRear,
  // vista grafica dei flow (/impostazioni/flow)
  faDiagramProject, faCircleExclamation, faFlagCheckered, faGripVertical,
  // usata dal 'riprova' sulle miniature di PhotoPicker
  faRotateRight,
  // menu Agenda (_nav.ts) e pulsanti "Pulisci" dei filtri in Impostazioni
  faCalendarDays, faCalendarCheck, faEraser
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faRotate, faPlus, faUser, faCog, faList, faRightFromBracket,
  faGear, faRoadBarrier, faLocationCrosshairs, faLocationDot, faBox, faPaperclip,
  faSquareParking, faTrash, faPenToSquare, faFloppyDisk, faXmark,
  faBook, faCamera, faPhotoFilm, faFileLines, faCircleDot,
  faWrench, faCar, faRefresh, faDeleteLeft, faCheck, faDownload, faBackward, faPlay,
  faMagnifyingGlass, faBars, faTriangleExclamation, faPen, faArrowUpRightFromSquare, faArrowDown, faArrowUp, faTrashCan, faSave, faArrowsLeftRight, faArrowRight, faFilter, faTableColumns, faPerson, faMagnifyingGlassArrowRight, faClock, faPeopleGroup, faHome, faAngleDown, faAngleUp, faCircle, faTable, faStop, faEye, faHammer, faX, faPeopleCarryBox, faSun, faMoon,faShareFromSquare,faClockRotateLeft,faFilePdf,faArrowRotateBack,faCopy,faCalculator, faListCheck,faLock, faRoute,faLinkSlash, faFileImport,faClipboardList,
  faScrewdriverWrench, faChevronLeft, faChevronRight, faChevronUp, faChevronDown,
  faArrowLeft, faCircleInfo, faNoteSticky, faUsers, faUserGroup, faFolderOpen, faCircleCheck, faCalendarDay,
  faSignature, faPaperPlane, faBrain, faTruck, faEnvelope, faEnvelopeOpen, faMobileScreen, faArrowRotateRight,faFaceFrown, faMessage, faNoteSticky, faRoad,
  faSnowflake, faCloudSun, faCloudArrowDown, faStopwatch, faBuilding, faHeart, faPaintRoller,
  faFileExcel, faRightLeft,
  faDiagramProject, faCircleExclamation, faFlagCheckered, faGripVertical, faRotateRight,
  faCarSide, faGasPump, faKey, faShieldHalved, faOilCan, faCarBattery, faGears,
  faDroplet, faToolbox, faBroom, faHandshake, faStar, faTag, faBolt,
  faTruckPickup, faSprayCanSparkles, faWindowMaximize, faCarRear,
  faCalendarDays, faCalendarCheck, faEraser
)



// Configura il gestore aggiornamenti Service Worker
setupServiceWorkerUpdateHandler();

// CModal (senza backdrop="static") si chiude se rileva un mousedown su window fuori dal
// suo contenuto. I popup SweetAlert sono appesi al body, quindi confermare uno Swal
// aperto da dentro un modale (es. "Inverti gomme" in depositoGomme) chiudeva il modale.
// Il mousedown nello Swal si ferma sul document e non arriva al listener del modale.
document.addEventListener('mousedown', (e) => {
  if ((e.target as Element | null)?.closest?.('.swal2-container')) e.stopPropagation();
});

// Sorgente dei wizard configurabili: la tabella `wizard_flows` su api-dev.
// Qui si registra solo il "come si caricano": la richiesta parte quando una
// pagina monta un <WizardHost>, non all'avvio.
setFlowLoader(() => apiFlow.flowsRuntimeGet());

// Funzione per inizializzare l'app
async function initApp() {
  try {
    // Carica CoreUI in modo asincrono
    const CoreuiVue = await import('@coreui/vue-pro');

    // Dispatch l'azione per controllare l'autenticazione all'avvio
    await store.dispatch(ActionTypes.CHECK_AUTH_ON_LOAD);

    // Crea l'app Vue
    const app = createApp(App)




    // Usa CoreUI prima di montare l'app
    if (CoreuiVue.default) {
      app.use(CoreuiVue.default);
    }

    app.use(createPinia())
    app.use(router)
    app.use(VueAxios, axios)
    app.use(VueCookies)
    app.use(store);
    app.use(I18NextVue, { i18next })


    app.component('font-awesome-icon', FontAwesomeIcon)

    // Monta l'app solo dopo che tutto è stato caricato
    app.mount('#app')

    // Rimuovi il flag di retry dopo il successo
    sessionStorage.removeItem('app_init_retry');

    console.log('App inizializzata con successo');
  } catch (error) {
    console.error('Errore durante l\'inizializzazione dell\'app:', error);

    // In caso di errore, prova a ricaricare la pagina una volta
    if (!sessionStorage.getItem('app_init_retry')) {
      sessionStorage.setItem('app_init_retry', '1');
      console.log('Tentativo di ricaricamento...');
      window.location.reload();
    } else {
      // Se anche il retry fallisce, mostra un messaggio all'utente
      document.getElementById('app')!.innerHTML = `
        <div style="display: flex; align-items: center; justify-content: center; height: 100vh; flex-direction: column; font-family: Arial, sans-serif;">
          <h2>Errore di caricamento</h2>
          <p>Si è verificato un errore durante il caricamento dell'applicazione.</p>
          <button onclick="window.location.reload()" style="padding: 10px 20px; margin-top: 20px; cursor: pointer;">
            Ricarica la pagina
          </button>
        </div>
      `;
    }
  }
}

// Avvia l'inizializzazione
initApp();
